import { useEffect, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { Sparkles, X } from 'lucide-react';
import { Button } from './ui/button';

export const DailyReflection = () => {
  const [message, setMessage] = useState<string | null>(null);
  const [isVisible, setIsVisible] = useState(true);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    loadReflection();
  }, []);

  const loadReflection = async () => {
    try {
      // Check if user has already seen today's reflection
      const today = new Date().toISOString().split('T')[0];
      const lastSeenKey = 'daily-reflection-seen';
      const lastSeen = localStorage.getItem(lastSeenKey);
      
      if (lastSeen === today) {
        console.log('User has already seen today\'s reflection');
        setIsLoading(false);
        return;
      }

      const { data, error } = await supabase.functions.invoke('daily-reflection');
      
      if (error) {
        console.error('Error loading daily reflection:', error);
        return;
      }

      if (data?.message) {
        setMessage(data.message);
        // Mark today's reflection as seen
        localStorage.setItem(lastSeenKey, today);
      }
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setIsLoading(false);
    }
  };

  if (!isVisible || !message || isLoading) {
    return null;
  }

  return (
    <div className="animate-fade-in">
      <div className="relative w-full bg-card border border-border/60 rounded-2xl p-6 shadow-soft">
        <Button
          variant="ghost"
          size="icon"
          className="absolute top-3 right-3 h-7 w-7 rounded-full hover:bg-muted/50 opacity-60 hover:opacity-100 transition-opacity"
          onClick={() => setIsVisible(false)}
        >
          <X className="h-4 w-4 text-muted-foreground" />
        </Button>

        <div className="flex items-start gap-4">
          <div className="flex-shrink-0 w-11 h-11 rounded-full bg-primary/10 flex items-center justify-center">
            <Sparkles className="w-5 h-5 text-primary" />
          </div>

          <div className="flex-1 space-y-1 pr-6">
            <p className="text-[11px] uppercase tracking-[0.16em] text-muted-foreground font-semibold">
              A moment for you
            </p>
            <p className="text-lg leading-relaxed text-foreground font-light" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
              {message}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
